// Pantalla previa a la prueba
import { useEffect, useState }   from "react";
import { useNavigate, useParams } from "react-router-dom";
import api                        from "../api";

export default function PruebaIntro() {
  const { id }     = useParams();
  const nav        = useNavigate();
  const [meta,set] = useState(null);
  const [err ,setE] = useState("");

  /* ─ fetch meta ─ */
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get(`/pruebas/${id}`);
        if (alive) set(data.meta);                         // ⬅️ sólo la parte meta
      } catch (e) {
        console.error(e);
        if (alive) setE(e.response?.data?.detail || "Error al cargar la prueba.");
      }
    })();
    return () => { alive = false; };
  }, [id]);

  if (err)  return <p className="text-red-600">{err}</p>;
  if (!meta) return <p>Cargando…</p>;

  /* ─ estado no disponible ─ */
  if (meta.status !== "disponible")
    return <p className="text-yellow-600">
      Esta prueba está <strong>{meta.status}</strong>.
    </p>;

  /* ─ render intro ─ */
  return (
    <div className="max-w-xl mx-auto bg-white p-8 shadow rounded-xl">
      <h1 className="text-2xl font-bold mb-4">
        {meta.titulo || `${meta.tipo} ${meta.numero}`}
      </h1>

      <p className="mb-2">
        Preguntas: {meta.preguntas} &nbsp;|&nbsp; Duración: {meta.duracion_min} min
      </p>

      <p className="mb-6 text-sm text-gray-600">
        Lee cuidadosamente cada pregunta y selecciona la alternativa. Puedes
        moverte libremente; el temporizador no se detendrá.
      </p>

      <button
        onClick={() => nav(`/app/pruebas/${id}/run`)}
        className="bg-indigo-600 text-white px-6 py-3 rounded-full hover:bg-indigo-700 w-full"
      >
        Comenzar
      </button>
    </div>
  );
}
